import {RootState} from '@/store';
import {State} from './state';
import {ActionTree} from 'vuex';

import {
  FETCH_USER_LIST,
  CREATE_USER_LIST,
  SET_USER_LIST,
  UPDATE_REGISTER_USER_FORM_VISIBILITY,
  SET_REGISTER_USER_FORM_VISIBILITY,
  UPDATE_SELECTED_USER,
  SET_SELECTED_USER,
  CREATE_NEW_USER,
  UPDATE_USER_LIST,
  UPDATE_USER,
  ADD_USER_TO_LIST,
  FETCH_USER_TYPE_LIST,
  SET_USER_TYPE_LIST,
  FETCH_USER_PROFILES,
  SET_USER_PROFILES,
  UPDATE_SELECTED_USER_PROFILES,
  UPDATE_CURRENT_USER_TAB,
  SET_CURRENT_USER_TAB,
  FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  UPDATE_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  SET_USER_PROFILE_FUNCTIONALITIES_GROUPED,
  FETCH_USER_FUNCTIONALITY_RESTRICTIONS,
  UPDATE_USER_FUNCTIONALITY_RESTRICTIONS,
  SET_USER_FUNCTIONALITY_RESTRICTIONS,
  FETCH_CLIENT_CONTRACTS,
  SET_CLIENT_CONTRACTS,
  FETCH_USER_BONDS_LIST,
  SET_USER_BONDS_LIST,
  UPDATE_USER_BONDS,
  UPDATE_SELECTED_BOND,
  SET_SELECTED_BOND,
  CREATE_BOND,
  UPDATE_BOND,
  UPDATE_BOND_LIST,
  ADD_BOND_TO_LIST,
  FETCH_LOCALE_TYPES_LIST,
  SET_LOCALE_TYPES_LIST,
  UPDATE_EMAIL_CONFIRMATION,
  FETCH_EMAIL_CONFIRMATION,
  SET_CONFIRMATION_EMAIL,
  DELETE_USER_BONDS,
  FETCH_USER_REPORT, FETCH_ROLE_CLASSIFICATIONS, SET_ROLE_CLASSIFICATIONS,
} from './types';
import {userApi} from '@/api/user.api';
import {userTypeApi} from '@/api/userType.api';
import {profileApi} from '@/api/profile.api';
import {IProfile} from '@/modules/profile/models';
import {IUser} from '@/modules/user/models';
import {clientContractApi} from '@/api/clientcontract.api';
import {bondApi} from '@/api/bond.api';
import {MessageService} from '@/services/messageService';
import {IBond} from '@/models/Bond';
import {IRoleClassification} from '@/models/IRoleClassification';

export const actions: ActionTree<State, RootState> = {

  async [FETCH_USER_LIST]({commit}, isOnlyActive: boolean) {
    return userApi.getAll(isOnlyActive).catch((error: any) => {
      MessageService.Error('Erro', error);
    });
  },
  async [CREATE_USER_LIST]({commit}, payload: State) {
    commit(SET_USER_LIST, payload);
  },
  async [UPDATE_REGISTER_USER_FORM_VISIBILITY]({commit}, payload: boolean) {
    commit(SET_REGISTER_USER_FORM_VISIBILITY, payload);
  },
  async [UPDATE_SELECTED_USER]({commit}, payload: State) {
    commit(SET_SELECTED_USER, payload);
  },
  async [UPDATE_USER_LIST]({commit}, payload: IUser) {
    commit(ADD_USER_TO_LIST, payload);
  },
  async [UPDATE_BOND_LIST]({commit}, payload: IBond[]) {
    commit(ADD_BOND_TO_LIST, payload);
  },
  async [CREATE_NEW_USER]({commit}, payload: IUser) {
    return userApi.addUser(payload).catch((error: any) => {
      if (error.response.data.Message) {
        MessageService.Error('Erro', error.response.data.Message);
      }
      throw error;
    });
  },
  async [UPDATE_USER]({commit}, payload: IUser) {
    return userApi.updateUser(payload).catch((error: any) => {
      if (error.response.data.Message) {
        MessageService.Error('Erro', error.response.data.Message);
      }
      throw error;
    });
  },
  async [FETCH_USER_TYPE_LIST]({commit}, payload: State) {
    commit(SET_USER_TYPE_LIST, (await userTypeApi.getAll()).data);
  },
  async [FETCH_USER_PROFILES]({commit}, payload: number) {
    return userApi.getUserProfiles(payload).catch((error: any) => {
      MessageService.Error('Erro', error);
    });
  },
  async [UPDATE_SELECTED_USER_PROFILES]({commit}, payload: IProfile[]) {
    commit(SET_USER_PROFILES, payload);
  },
  async [UPDATE_CURRENT_USER_TAB]({commit}, payload: string) {
    commit(SET_CURRENT_USER_TAB, payload);
  },
  async [FETCH_USER_PROFILE_FUNCTIONALITIES_GROUPED]({commit}, payload: string) {
    return profileApi.getProfileFunctionalitiesGrouped(payload).catch((error: any) => {
      MessageService.Error('Erro', error);
    });
  },
  async [UPDATE_USER_PROFILE_FUNCTIONALITIES_GROUPED]({commit}, payload: any[]) {
    commit(SET_USER_PROFILE_FUNCTIONALITIES_GROUPED, payload);
  },
  async [FETCH_USER_FUNCTIONALITY_RESTRICTIONS]({commit}, payload: number) {
    return userApi.getUserFunctionalityRestrictions(payload).catch((error: any) => {
      MessageService.Error('Erro', error);
    });
  },
  async [UPDATE_USER_FUNCTIONALITY_RESTRICTIONS]({commit}, payload: number[]) {
    commit(SET_USER_FUNCTIONALITY_RESTRICTIONS, payload);
  },
  async [FETCH_CLIENT_CONTRACTS]({commit}, payload: State) {
    commit(SET_CLIENT_CONTRACTS, (await clientContractApi.getAll()).data);
  },
  async [FETCH_USER_BONDS_LIST]({commit}, payload: number) {
    return bondApi.getBondsByUser(payload).catch((error: any) => {
      MessageService.Error('Erro', error);
    });
  },
  async [UPDATE_USER_BONDS]({commit}, payload: any[]) {
    commit(SET_USER_BONDS_LIST, payload);
  },
  async [UPDATE_SELECTED_BOND]({commit}, payload: State) {
    commit(SET_SELECTED_BOND, payload);
  },
  async [CREATE_BOND]({commit}, payload: { idUser: number, bonds: IBond[] }) {
    return bondApi.saveBond(payload.idUser, payload.bonds).catch((error: any) => {
      MessageService.Error('Erro', error);
    });
  },
  async [UPDATE_BOND]({commit}, payload: IBond) {
    return bondApi.updateBond(payload);
  },
  async [FETCH_LOCALE_TYPES_LIST]({commit}, payload: number) {
    commit(SET_LOCALE_TYPES_LIST, (await bondApi.getLocaleTypes(payload)).data);
  },
  async [FETCH_EMAIL_CONFIRMATION]({commit}, payload: number) {
    return userApi.confirmemail(payload);
  },
  async [UPDATE_EMAIL_CONFIRMATION]({commit}, payload: number) {
    commit(SET_CONFIRMATION_EMAIL, payload);
  },
  async [DELETE_USER_BONDS]({commit}, payload: any) {
    return userApi.deleteUserBonds(payload.id, payload.bondIds);
  },
  async [FETCH_USER_REPORT]({commit}, payload: any) {
    return userApi.getUsersReport();
  },
  async [FETCH_ROLE_CLASSIFICATIONS]({commit}) {
    userApi.getRoleClassifications()
      .then((roles: any) => {
        commit(SET_ROLE_CLASSIFICATIONS, roles.data);
      })
      .catch((error: any) => {
        MessageService.Error('Erro', error);
      });
  },
};
